import { Component, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl } from '@angular/forms';
import { ViewStateEnum } from '../../../core/enums/view-state.enum';
import { formatISO9075, intlFormatDistance } from 'date-fns';
import { CalculationStore } from '../../stores/calculation.store';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-grant-delegated-access-modal',
  templateUrl: './grant-delegated-access-modal.component.html',
  styleUrls: ['./grant-delegated-access-modal.component.scss'],
  standalone: false,
})
export class GrantDelegatedAccessModalComponent implements OnDestroy {
  accessCurrentlyGranted = false;

  state: ViewStateEnum = ViewStateEnum.Ready;
  calculationSubscription: Subscription;
  delegatedDuration = new FormControl('3600000');
  grantedUntil: string;

  constructor(public activeModal: NgbActiveModal,
              private readonly calculationStore: CalculationStore) {
  }

  private _calculationId: string;

  get calculationId(): string {
    return this._calculationId;
  }

  set calculationId(value: string) {
    this._calculationId = value;

    this.calculationSubscription?.unsubscribe();

    this.calculationSubscription = this.calculationStore.get(value).subscribe(calculation => {
      const accessDelegatedToAdminUntil = calculation.accessDelegatedToAdminUntil;

      this.accessCurrentlyGranted = !(accessDelegatedToAdminUntil === undefined || accessDelegatedToAdminUntil < new Date());

      if (this.accessCurrentlyGranted) {
        this.grantedUntil = `${intlFormatDistance(accessDelegatedToAdminUntil, new Date(), { locale: 'fr-CA' })} (${formatISO9075(accessDelegatedToAdminUntil)})`;
      }
    });
  }

  ngOnDestroy() {
    this.calculationSubscription?.unsubscribe();
  }

  async delegateAccess() {
    this.state = ViewStateEnum.Refreshing;

    await this.calculationStore.grantDelegatedAccess(this.calculationId, {
      duration: parseInt(this.delegatedDuration.value),
    });

    this.state = ViewStateEnum.Ready;
  }

  async stopDelegatingAccess() {
    this.state = ViewStateEnum.Refreshing;

    await this.calculationStore.grantDelegatedAccess(this.calculationId, {
      duration: 0,
    });

    this.state = ViewStateEnum.Ready;
  }
}
